/**************************************************
 * Nombre:       Dialogo_Espacio_Notificaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import {guardarFechaAct} from "../../../Servicios/BD/Actualizadores/guardarFechaAct";
import {combinarFechasHora} from "../../../Modulo_formularios/Funciones/combinarFechasHora";
import Formulario_Espacio from "../../Formularios/Espacios/Formulario_Espacio";
import Formulario_Espacio_Notificaciones from "../../Formularios/Espacios/Formulario_Espacio_Notificaciones";

const Dialogo_Espacio_Notificaciones = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        let doxImg = await subirImagenHostingFile(entidad.img)
        entidad.img = doxImg.data

        let doxImgDos = await subirImagenHostingFile(entidad.imgDos)
        entidad.imgDos = doxImgDos.data

        iniciarCarga('Subiendo Datos')

        if (entidad.fechaUno && entidad.horaUno){
            entidad.fechaUno = combinarFechasHora({fecha: entidad.fechaUno, fechaHora: entidad.horaUno})
        }

        if (entidad.fechaDos && entidad.horaDos){
            entidad.fechaDos = combinarFechasHora({fecha: entidad.fechaDos, fechaHora: entidad.horaDos})
        }

        if (entidad.fechaTres && entidad.horaTres){
            entidad.fechaTres = combinarFechasHora({fecha: entidad.fechaTres, fechaHora: entidad.horaTres})
        }



        let dox = await guardarDoc('espacios', entidad)
        await guardarFechaAct('espacios')
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('espacios', datos.id)
        terminar({aviso: 'Espacio borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Espacio_Notificaciones props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Espacio_Notificaciones